import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {
  EditPlanRulesTemplateRequest,
  CreatePlanRulesTemplateRequest,
} from 'planning-portal-library/src/lib/core/domain';
import { PlanRulesTemplate } from 'planning-portal-library/src/lib/core/domain/models/plan-rules-template';
import { injectEnvironment } from 'planning-portal-library/src/lib/core/environments/environment.token';
import { PlanRulesTemplateRepository } from 'planning-portal-library/src/lib/core/repositories/plan-rules-template.repository';
import { catchError, map, Observable } from 'rxjs';
import { PlanRulesTemplateApiUrls } from './plan-rules-template-api-urls';
import { PlanRulesTemplateWebEntity } from './entities/plan-rules-template-web-entity';
import { BaseResponse } from '../../../shared/base.response';
import { PlanRulesTemplateWebRepositoryMapper } from './entities/plan-rules-template-web-repository-mapper';

@Injectable({ providedIn: 'root' })
export class PlanRulesTemplateWebRepository extends PlanRulesTemplateRepository {
  private readonly environment = injectEnvironment();
  private readonly planRulesTemplateMapper =
    new PlanRulesTemplateWebRepositoryMapper();
  constructor(private readonly http: HttpClient) {
    super();
  }
  GetPlanRulesTemplateByPlanId(request: string): Observable<PlanRulesTemplate> {
    return this.http
      .get<BaseResponse<PlanRulesTemplateWebEntity>>(
        `${this.environment.url}${PlanRulesTemplateApiUrls.GetPlanRulesTemplateByPlanId}` + request,       
      )
      .pipe(
        map(
          (response: BaseResponse<PlanRulesTemplateWebEntity>) =>
            response.result!
        ),
        catchError((err) => {
          throw err;
        })
      )
      .pipe(map(this.planRulesTemplateMapper.mapFrom));
  }

  EditPlanRulesTemplate(
    request: EditPlanRulesTemplateRequest
  ): Observable<string> {
    return this.http
      .post<BaseResponse<string>>(
        `${this.environment.url}${PlanRulesTemplateApiUrls.UpdatePlanRulesTemplate}`,
        request
      )
      .pipe(
        map((data) => {
          return data.result!;
        }),
        catchError((err) => {
          throw err;
        })
      );
  }
  CreatePlanRulesTemplate(
    request: CreatePlanRulesTemplateRequest
  ): Observable<string> {
    return this.http
      .post<BaseResponse<string>>(
        `${this.environment.url}${PlanRulesTemplateApiUrls.CreatePlanRulesTemplate}`,
        request
      )
      .pipe(
        map((data) => {
          return data.result!;
        }),
        catchError((err) => {
          throw err;
        })
      );
  }
}
